import { createApp } from 'vue';
import store from 'shared/store'
import EnrollmentFormConfigurator from './enrollmentFormConfigurator.vue';

const enrollmentFormConfigurator = document.getElementById('enrollment-form-configurator');

if (enrollmentFormConfigurator) {
	const app = createApp({
		name: 'EnrollmentFormConfiguratorApp'
	});
	app.component('enrollment-form-configurator', EnrollmentFormConfigurator);
	app.use(store);
	app.mount(enrollmentFormConfigurator);
}